import { render, staticRenderFns } from "./ProfileSettingPassword.vue?vue&type=template&id=5245e2ca&"
import script from "./ProfileSettingPassword.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports